var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.391,
    height: 22.5,
    viewBox: "0 0 14.391 22.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_9",
    "data-name": "Artboard 9",
    transform: "translate(-20.66 -4.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23839",
    "data-name": "Path 23839",
    d: "M27.855,17.649A3.465,3.465,0,0,0,31.327,14.2V8.258a3.471,3.471,0,0,0-6.943,0V14.2A3.465,3.465,0,0,0,27.855,17.649Zm-1.42-9.39a1.42,1.42,0,0,1,2.841,0V14.2a1.42,1.42,0,0,1-2.841,0Zm2.446,12.813v3.7h2.5a1.019,1.019,0,1,1,0,2.038H24.333a1.019,1.019,0,1,1,0-2.038h2.5v-3.7a6.922,6.922,0,0,1-5.92-6.823,1.026,1.026,0,0,1,2.051,0,4.894,4.894,0,0,0,9.788,0,1.026,1.026,0,0,1,2.051,0A6.922,6.922,0,0,1,28.881,21.072Z",
    transform: "translate(0)",
    fill: "#757575",
    stroke: "#f9f9f9",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeak);
export default __webpack_public_path__ + "static/media/speak.397f2069849fc211dc710dc7e65e56d7.svg";
export { ForwardRef as ReactComponent };